import { render, staticRenderFns } from "./c_tab.vue?vue&type=template&id=14a594a6&scoped=true"
import script from "./c_tab.vue?vue&type=script&lang=js"
export * from "./c_tab.vue?vue&type=script&lang=js"
import style0 from "./c_tab.vue?vue&type=style&index=0&id=14a594a6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a594a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a594a6')) {
      api.createRecord('14a594a6', component.options)
    } else {
      api.reload('14a594a6', component.options)
    }
    module.hot.accept("./c_tab.vue?vue&type=template&id=14a594a6&scoped=true", function () {
      api.rerender('14a594a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_tab.vue"
export default component.exports